import { configureStore } from "@reduxjs/toolkit";
import themeSettingSlice from "./themeSettingSlice";
import sidebarSlice from "./sidebarSlice";
import courseOverviewSlice from "./courseOverviewSlice";
import courseLessonSlice from "./courseLessonSlice";
import quizSlice from "./quizSlice";
import assignSlice from "./assignSlice";
import forumSlice from "./forumSlice";
import discussionSlice from "./disscusionSlice";

const store = configureStore({
  reducer: {
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
    courseOverviewSlice: courseOverviewSlice,
    courseLessonSlice: courseLessonSlice,
    quizSlice: quizSlice,
    assignSlice: assignSlice,
    forumSlice: forumSlice,
    discussionSlice: discussionSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ReturnType<typeof store.dispatch>;

export default store;
